import { styled } from '@uhg-abyss/web/tools/styled';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';

export const StyledFontSizeModal = styled(ModalDialog, {
  '.abyss-modal-base-header': {
    fontSize: '28px !important',
  },
  '.abyss-modal-base-header-container': {
    padding: '16px',
  },
  '.abyss-modal-base-body': {
    p: {
      marginBottom: 0,
    },
    ul: {
      paddingLeft: '1.5rem !important',
    },
  },
});
